module.exports = __webpack_public_path__ + "img/Secured-by-apaym-pci-dss.f1fb0fa0.png";